export class FlowComponentIcons
{
    public readonly DefaultFlowIcon = 'visualDesigner/flow/components/default_flow_icon';

    // I/O
    // ---

    // Notifications
    public readonly SendEmail = 'visualDesigner/flow/components/io/notifications/_send_email';
    public readonly SendPush = 'visualDesigner/flow/components/io/notifications/send_push';
    public readonly SendSMS = 'visualDesigner/flow/components/io/notifications/send_sms';

    // Database
    public readonly ReadDatabase = 'visualDesigner/flow/components/io/database/read_database';
    public readonly WriteDatabase = 'visualDesigner/flow/components/io/database/write_database';
    public readonly ReadRedshift = 'visualDesigner/flow/components/io/database/read_redshift';
    public readonly WriteRedshift = 'visualDesigner/flow/components/io/database/write_redshift';

    // Elastic Search
    public readonly ReadElasticSearch = 'visualDesigner/flow/components/io/elastic_search/read_elastic_search';
    public readonly WriteElasticSearch = 'visualDesigner/flow/components/io/elastic_search/write_elastic_search';

    // S3
    public readonly ReadS3 = 'visualDesigner/flow/components/io/s3/read_s3';
    public readonly ReadS3Stream = 'visualDesigner/flow/components/io/s3/read_s3_stream';
    public readonly WriteS3 = 'visualDesigner/flow/components/io/s3/write_s3';

    // HTTP
    public readonly ReadHttp = 'visualDesigner/flow/components/io/http/read_http';
    public readonly WriteHttp = 'visualDesigner/flow/components/io/http/write_http';
    public readonly ReadOAuth = 'visualDesigner/flow/components/io/http/read_oauth';
    public readonly WriteOAuth = 'visualDesigner/flow/components/io/http/write_oauth';

    // Logical
    // -------

    // Filter
    public readonly BasicFilter = 'visualDesigner/flow/components/logical/filter/basic_filter';
    public readonly ExpressionFilter = 'visualDesigner/flow/components/logical/filter/expression_filter';
    public readonly ScriptFilter = 'visualDesigner/flow/components/logical/filter/script_filter';

    // Frame Makers
    public readonly JsonToFrame = 'visualDesigner/flow/components/logical/frame_makers/json_to_frame';
    public readonly MapToFrame = 'visualDesigner/flow/components/logical/frame_makers/map_to_frame';
    public readonly StringToFrame = 'visualDesigner/flow/components/logical/frame_makers/string_to_frame';
    public readonly NumberToFrame = 'visualDesigner/flow/components/logical/frame_makers/number_to_frame';
    public readonly SimpleCounter = 'visualDesigner/flow/components/logical/frame_makers/simple_counter';

    // Operations
    public readonly CombineFrames = 'visualDesigner/flow/components/logical/operations/combine_frames';
    public readonly EachRow = 'visualDesigner/flow/components/logical/operations/each_row';
    public readonly ExtractColumn = 'visualDesigner/flow/components/logical/operations/extract_column';
    public readonly ExtractColumns = 'visualDesigner/flow/components/logical/operations/extract_columns';
    public readonly ExtractNestedFrames = 'visualDesigner/flow/components/logical/operations/extract_nested_frames';
    public readonly GroupBy = 'visualDesigner/flow/components/logical/operations/group_by';
    public readonly If = 'visualDesigner/flow/components/logical/operations/if';
    public readonly Join = 'visualDesigner/flow/components/logical/operations/join';
    public readonly SplitColumns = 'visualDesigner/flow/components/logical/operations/split_columns';
    public readonly SplitRows = 'visualDesigner/flow/components/logical/operations/split_rows';
    public readonly Map = 'visualDesigner/flow/components/logical/operations/map';
    public readonly RegExp = 'visualDesigner/flow/components/logical/operations/regexp';

    // Random
    public readonly RandomIntegers = 'visualDesigner/flow/components/logical/random/random_integers';
    public readonly RandomWords = 'visualDesigner/flow/components/logical/random/random_words';

    // Text
    public readonly TemplatedText = 'visualDesigner/flow/components/logical/text/templated_text';

    // Transformers
    public readonly CsvToFrame = 'visualDesigner/flow/components/logical/transformers/csv_to_frame';
    public readonly FrameToJson = 'visualDesigner/flow/components/logical/transformers/frame_to_json';
}

export class SurfaceComponentIcons
{
    // Default
    public readonly DefaultSurfaceIcon = 'visualDesigner/flow/components/default_flow_icon';

    // Surface Icons
    public readonly Table = 'visualDesigner/surface/table';
    public readonly Box = 'visualDesigner/surface/box';
    public readonly Button = 'visualDesigner/surface/button';
    public readonly ToggleButtonSet = 'visualDesigner/surface/toggle_button_set';
    public readonly ButtonGroup = 'visualDesigner/surface/button_group';
    public readonly Card = 'visualDesigner/surface/card';
    public readonly Checkbox = 'visualDesigner/surface/checkbox';
    public readonly DateInput = 'visualDesigner/surface/date_input';
    public readonly DateRangeInput = 'visualDesigner/surface/date_range_input';
    public readonly Dropdown = 'visualDesigner/surface/dropdown';
    public readonly Image = 'visualDesigner/surface/image';
    public readonly Label = 'visualDesigner/surface/label';
    public readonly LinkButton = 'visualDesigner/surface/link_button';
    public readonly Map = 'visualDesigner/surface/map';
    public readonly Navigation = 'visualDesigner/surface/navigation';
    public readonly NumericInput = 'visualDesigner/surface/numeric_input';
    public readonly Paragraph = 'visualDesigner/surface/paragraph';
    public readonly ProgressBar = 'visualDesigner/surface/progress_bar';
    public readonly RadioButtonGroup = 'visualDesigner/surface/radio_buttons';
    public readonly RangeSlider = 'visualDesigner/surface/range_slider';
    public readonly Slider = 'visualDesigner/surface/slider';
    public readonly SqlEditor = 'visualDesigner/surface/sql_editor';
    public readonly JsonEditor = 'visualDesigner/surface/json_editor';
    public readonly SoundPlayer = 'visualDesigner/surface/sound_player';
    public readonly Spreadsheet = 'visualDesigner/surface/spreadsheet';
    public readonly Switch = 'visualDesigner/surface/switch';
    public readonly Tabs = 'visualDesigner/surface/tabs';
    public readonly RichTextEditor = 'visualDesigner/surface/rich_text_editor';
    public readonly TextArea = 'visualDesigner/surface/text_area';
    public readonly TextInput = 'visualDesigner/surface/text_input';
    public readonly Chart = 'visualDesigner/surface/chart';
    public readonly Calendar = 'visualDesigner/surface/calendar';
    public readonly FilePicker = 'visualDesigner/surface/file_picker';
    public readonly TooltipDecorator = 'visualDesigner/surface/tooltip_decorator';
    public readonly PopoverContainer = 'visualDesigner/surface/popover_container';
    public readonly TimeInput = 'visualDesigner/surface/time_input';
    public readonly SplitView = 'visualDesigner/surface/split_view';
    public readonly Text = 'visualDesigner/surface/text';
    public readonly Icon = 'visualDesigner/surface/icon';
    public readonly VideoPlayer = 'visualDesigner/surface/video_player';
    public readonly Heatmap = 'visualDesigner/surface/heatmap';
    public readonly Twilio = 'visualDesigner/surface/twilio';

    // Visual Components
    public readonly ChartPie = 'visualDesigner/surface/chart_pie';
    public readonly Checkboxes = 'visualDesigner/surface/checkboxes';
}

export class TopBarIcons
{
    public readonly Play = 'visualDesigner/topbar/play';
    public readonly Stop = 'visualDesigner/topbar/stop';
    public readonly FlowTab = 'visualDesigner/topbar/flow_tab';
    public readonly SurfaceTab = 'visualDesigner/topbar/surface_tab';
    public readonly Cloud = 'visualDesigner/topbar/cloud';
    public readonly Plus = 'visualDesigner/topbar/plus';

    public readonly Properties = 'visualDesigner/topbar/properties';
    public readonly Grid = 'visualDesigner/topbar/grid';
    public readonly Pages = 'visualDesigner/topbar/pages';
    public readonly CollapsedMenu = 'visualDesigner/topbar/collapsed_menu';
    public readonly Preview = 'visualDesigner/topbar/preview';
    public readonly Publish = 'visualDesigner/topbar/publish';
    public readonly GroupAdd = 'visualDesigner/topbar/group_add';
    public readonly Back = 'visualDesigner/topbar/back';

    public readonly Dot = 'visualDesigner/topbar/dot';
    public readonly Help = 'visualDesigner/topbar/help';
    public readonly Close = 'visualDesigner/topbar/close';

    public readonly ExpandMore = 'visualDesigner/topbar/expand_more';
    public readonly ExpandLess = 'visualDesigner/topbar/expand_less';
}

export class CellSettingsBarIcons
{
    public readonly Palette = 'visualDesigner/spreadsheet/cellSettings/palette';

    public readonly FormatPaint = 'visualDesigner/spreadsheet/cellSettings/format_paint';

    public readonly CurrencyUsd = 'visualDesigner/spreadsheet/cellSettings/currency_usd';
    public readonly Percent = 'visualDesigner/spreadsheet/cellSettings/percent';
    public readonly DecimalIncrease = 'visualDesigner/spreadsheet/cellSettings/decimal_increase';
    public readonly DecimalDecrease = 'visualDesigner/spreadsheet/cellSettings/decimal_decrease';

    public readonly FormatBold = 'visualDesigner/spreadsheet/cellSettings/format_bold';
    public readonly FormatItalic = 'visualDesigner/spreadsheet/cellSettings/format_italic';
    public readonly FormatUnderline = 'visualDesigner/spreadsheet/cellSettings/format_underline';
    public readonly FormatStrikethrough = 'visualDesigner/spreadsheet/cellSettings/format_strikethrough';

    public readonly FormatColorText = 'visualDesigner/spreadsheet/cellSettings/format_color_text';
    public readonly FormatColorFill = 'visualDesigner/spreadsheet/cellSettings/format_color_fill';

    public readonly BorderColor = 'visualDesigner/spreadsheet/cellSettings/border_color';
    public readonly BorderAll = 'visualDesigner/spreadsheet/cellSettings/border_all';
    public readonly BorderInside = 'visualDesigner/spreadsheet/cellSettings/border_inside';
    public readonly BorderHorizontal = 'visualDesigner/spreadsheet/cellSettings/border_horizontal';
    public readonly BorderVertical = 'visualDesigner/spreadsheet/cellSettings/border_vertical';
    public readonly BorderOutside = 'visualDesigner/spreadsheet/cellSettings/border_outside';
    public readonly BorderLeft = 'visualDesigner/spreadsheet/cellSettings/border_left';
    public readonly BorderTop = 'visualDesigner/spreadsheet/cellSettings/border_top';
    public readonly BorderRight = 'visualDesigner/spreadsheet/cellSettings/border_right';
    public readonly BorderBottom = 'visualDesigner/spreadsheet/cellSettings/border_bottom';
    public readonly BorderNone = 'visualDesigner/spreadsheet/cellSettings/border_none';
    public readonly BorderBottomDouble = 'visualDesigner/spreadsheet/cellSettings/border_bottom_double';

    public readonly FormatAlignLeft = 'visualDesigner/spreadsheet/cellSettings/format_align_left';
    public readonly FormatAlignCenter = 'visualDesigner/spreadsheet/cellSettings/format_align_center';
    public readonly FormatAlignRight = 'visualDesigner/spreadsheet/cellSettings/format_align_right';

    public readonly FormatVerticalAlignTop = 'visualDesigner/spreadsheet/cellSettings/format_vertical_align_top';
    public readonly FormatVerticalAlignCenter = 'visualDesigner/spreadsheet/cellSettings/format_vertical_align_center';
    public readonly FormatVerticalAlignBottom = 'visualDesigner/spreadsheet/cellSettings/format_vertical_align_bottom';

    public readonly TextWrappingDefault = 'visualDesigner/spreadsheet/cellSettings/text_wrapping_default';
    public readonly TextWrappingWrap = 'visualDesigner/spreadsheet/cellSettings/text_wrapping_wrap';
    public readonly TextWrappingClip = 'visualDesigner/spreadsheet/cellSettings/text_wrapping_clip';

    public readonly More = 'visualDesigner/spreadsheet/cellSettings/more';
}

export class MenuIcons
{
    public readonly Undo = 'visualDesigner/menu/undo';
    public readonly Redo = 'visualDesigner/menu/redo';
    public readonly Cut = 'visualDesigner/menu/cut';
    public readonly Copy = 'visualDesigner/menu/copy';
    public readonly Paste = 'visualDesigner/menu/paste';
}

export class ComponentIcons
{
    public readonly Gears = 'visualDesigner/flow/components/gears';

    public flow:FlowComponentIcons = new FlowComponentIcons();
    public surface:SurfaceComponentIcons = new SurfaceComponentIcons();
}

export class PlaceholderIcons
{
    public readonly BouncyChart = 'common/placeholders/bouncy_chart';
    public readonly DataFountain = 'common/placeholders/data_fountain';
}

export class DialogIcons
{
    public readonly AddOrganization = 'visualDesigner/common/dialogs/add_organization';
    public readonly AddSpace = 'visualDesigner/common/dialogs/add_space';
}

export class CommonIcons
{
    public placeholders:PlaceholderIcons = new PlaceholderIcons();
    public dialogs:DialogIcons = new DialogIcons();

    public readonly ArrowLeft = 'common/arrow_left';
    public readonly ArrowRight = 'common/arrow_right';
    public readonly ArrowDown = 'common/arrow_down';
    public readonly ArrowUp = 'common/arrow_up';
}

export class PanelHeaderIcons
{
    public readonly ClosePanel = 'visualDesigner/panels/headers/close_panel';
    public readonly Script = 'visualDesigner/panels/headers/script_header';
    public readonly DebugDataWire = 'visualDesigner/panels/headers/debug_data_wire';
    public readonly DebugDataBlock = 'visualDesigner/panels/headers/debug_data_block';
    public readonly DebugDataBlock2 = 'visualDesigner/panels/headers/debug_data_block2';
    public readonly ArrowRight = 'visualDesigner/panels/headers/panel_arrow_right';
    public readonly ArrowDown = 'visualDesigner/panels/headers/panel_arrow_down';
}

export class ConsolePanelIcons
{
    public readonly Info = 'visualDesigner/panels/console/info';
    public readonly Warning = 'visualDesigner/panels/console/warning';
    public readonly Error = 'visualDesigner/panels/console/error';
}

export class DebugDataPanelIcons
{
    public readonly AutosizeColumns = 'visualDesigner/panels/debugData/autosize_columns';
    public readonly TransposeGrid = 'visualDesigner/panels/debugData/transpose_grid';
    public readonly FilterColumns = 'visualDesigner/panels/debugData/filter_columns';
    public readonly EyeFilterColumns = 'visualDesigner/panels/debugData/eye_filter_columns';
}

export class PanelsIcons
{
    public readonly headers:PanelHeaderIcons = new PanelHeaderIcons();
    public readonly console:ConsolePanelIcons = new ConsolePanelIcons();
    public readonly debugData:DebugDataPanelIcons = new DebugDataPanelIcons();
}

export class DataTypeIcons
{
    public readonly Boolean = 'visualDesigner/dataTypes/boolean';
    public readonly Byte = 'visualDesigner/dataTypes/byte';
    public readonly Integer = 'visualDesigner/dataTypes/integer';
    public readonly Number = 'visualDesigner/dataTypes/number';
    public readonly String = 'visualDesigner/dataTypes/string';
    public readonly Currency = 'visualDesigner/dataTypes/currency';
    public readonly Date = 'visualDesigner/dataTypes/date';
    public readonly DateTime = 'visualDesigner/dataTypes/date_time';
    public readonly StringEnum = 'visualDesigner/dataTypes/string_enum';
    public readonly IntegerEnum = 'visualDesigner/dataTypes/integer_enum';
    public readonly BinaryData = 'visualDesigner/dataTypes/binary_data';
    public readonly Frame = 'visualDesigner/dataTypes/frame';
    public readonly Error = 'visualDesigner/dataTypes/error';
    public readonly Empty = 'visualDesigner/dataTypes/empty';
}

export class SpreadsheetIcons
{
    public readonly Hide = 'visualDesigner/spreadsheet/hide';
    public readonly Sum = 'visualDesigner/spreadsheet/sum';
    public readonly Cloud = 'visualDesigner/spreadsheet/cloud';
    public readonly Help = 'visualDesigner/spreadsheet/help';
}

export class VisualDesignerIcons
{
    public topBar:TopBarIcons = new TopBarIcons();
    public panels:PanelsIcons = new PanelsIcons();
    public components:ComponentIcons = new ComponentIcons();
    public dataTypes:DataTypeIcons = new DataTypeIcons();
    public spreadsheet:SpreadsheetIcons = new SpreadsheetIcons();
    public cellSettings:CellSettingsBarIcons = new CellSettingsBarIcons();
    public menu:MenuIcons = new MenuIcons();
}

export class AppLaunchIcons
{
    // public readonly App1 = 'workspace/appLaunch/app-1';
    // public readonly App2 = 'workspace/appLaunch/app-2';
    // public readonly App3 = 'workspace/appLaunch/app-3';
    // public readonly App4 = 'workspace/appLaunch/app-4';
    // public readonly App5 = 'workspace/appLaunch/app-5';
    // public readonly App6 = 'workspace/appLaunch/app-6';
    // public readonly App7 = 'workspace/appLaunch/app-7';
    // public readonly App8 = 'workspace/appLaunch/app-8';
    // public readonly App9 = 'workspace/appLaunch/app-9';
    public readonly ToggleOn = 'workspace/togglers/toggle-apps-on-noshadow';
    public readonly ToggleOff = 'workspace/togglers/toggle-apps-off-noshadow';
}

export class WorkspaceIcons
{
    public readonly appLaunch:AppLaunchIcons = new AppLaunchIcons();
}

export class GuideIcons
{
    public readonly Arrow = 'guide/arrow';
}

export class WSPIcons
{
    public static readonly common:CommonIcons = new CommonIcons();
    public static readonly visualDesigner:VisualDesignerIcons = new VisualDesignerIcons();
    public static readonly workspace:WorkspaceIcons = new WorkspaceIcons();
    public static readonly guide:GuideIcons = new GuideIcons();
}

export enum WSPIconSize
{
    xlarge = 'xlarge',
    large = 'large',
    medium = 'medium',
    medium28 = 'medium28',
    medium24 = 'medium24',
    medium20 = 'medium20',
    medium18 = 'medium18',
    medium16 = 'medium16',
    small = 'small',
    xsmall = 'xsmall',
    xlarge_48 = 'xlarge_48',
    xlarge_64 = 'xlarge_64',
    xlarge_80 = 'xlarge_80',
    x2small = 'x2small'
}

export type WSPIconName = string;
